// Une adresse qui ne mene nulle part (audit B3, 28/09/2026).
//
// Elle renvoyait EN SILENCE a l'accueil. Un lien casse, une adresse mal
// recopiee depuis un e-mail, un favori d'une ancienne version : l'utilisateur
// se retrouvait sur le tableau de bord sans savoir que sa page n'existait pas
// -- et cherchait ce qu'il voulait dans le mauvais ecran.
//
// Dire que la page n'existe pas, et offrir le chemin du retour. Le serveur,
// lui, n'est pas concerne : cette page ne demande rien.
import { Link } from "react-router-dom";
import Layout from "../components/Layout";

export default function PageIntrouvable({ user, onLogout }) {
  return (
    <Layout user={user} onLogout={onLogout}>
      <div className="carte">
        <h2>Page introuvable</h2>
        <p>
          Cette adresse ne correspond à aucune page. Le lien est peut-être
          incomplet, ou la page a été déplacée.
        </p>
        <Link to="/" className="btn-accent">
          Retour à l'accueil
        </Link>
      </div>
    </Layout>
  );
}
